import { combineReducers } from 'redux'
import articles from './slices/articlesSlice'
import auth from './slices/authSlice'
import media from './slices/mediaSlice'
import newsletter from './slices/newsletterSlice'
import settings from './slices/settingsSlice'
import theme from './slices/themeSlice'
import milestones from './slices/milestonesSlice'
import loginHistory from './slices/loginLogSlice'
import articleVersions from './slices/articleVersionSlice'
import s3 from './slices/s3Slice'

const rootReducer = (asyncReducers) => (state, action) => {
	const combinedReducer = combineReducers({
		theme,
		auth,
		articles,
		articleVersions,
		newsletter,
		settings,
		media,
		milestones,
		loginHistory,
		s3,
		...asyncReducers,
	})
	return combinedReducer(state, action)
}

export default rootReducer
